<script setup lang="ts">
import { NewsPage } from '@features/news'
</script>

<template>
  <news-page />
</template>
